/*
в будущем использовать эту функцию для получения стейта
в старых местах где используется getServerState - заменить на эту
менять не сразу во всем проекте, чтобы не сломать контекст
*/
const getPreloadedState = <K = {}>(prefix: string): Promise<K> => {
    return new Promise((resolve, reject) => {
        try {
            if (typeof window !== 'undefined' &&
                window[`__PRELOADED_STATE_${prefix}__`]) {
                const state = typeof window[`__PRELOADED_STATE_${prefix}__`] === 'string'
                    ? JSON.parse(window[`__PRELOADED_STATE_${prefix}__`])
                    : window[`__PRELOADED_STATE_${prefix}__`];
                const store = { ...(state?.data || state) };
                delete window[`__PRELOADED_STATE_${prefix}__`];
                return resolve(store);
            }
            return reject(`Не удалось получить состояние для ${prefix}`);
        }
        catch (err) {
            return reject(`Состояние для ${prefix} не является валидным JSON`);
        }
    });
};
export default getPreloadedState;
